<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0">
        <el-row>
            <el-col class="align-left" :span="16" style="padding: 10px 20px 0">
                <item-input type="radio" :options="allFlows" v-model="active_group_name" style="width: max-content"></item-input>
            </el-col>
            <el-col class="align-right" :span="8" style="padding: 10px 10px 0">
                <el-button type="primary" size="mini" @click="setUserConfig" v-show="packageWithBarcode != '2'">清点查询配置</el-button>
                <el-button type="primary" size="mini" @click="loadNewFlowView" class="el-icon-plus">创建清点单</el-button>
                <el-button type="primary" size="mini" @click="printFlow" class="el-icon-printer">打印</el-button>
                <el-button type="danger" size="mini" @click="deleteFlow" class="el-icon-delete">删除</el-button>
            </el-col>
        </el-row>
        <item-instrument v-bind.sync="activeGroup && activeGroup.qx" :key="activeGroup && activeGroup.qx && activeGroup.qx.id" v-if="activeGroup && 2 == activeId">
            <el-radio-group slot="area1" v-model="activeId" size="small" style="text-align: left">
                <el-radio-button label="2">器械</el-radio-button>
                <el-radio-button label="1">耗材</el-radio-button>
            </el-radio-group>
        </item-instrument>
        <item-consumable v-bind.sync="activeGroup && activeGroup.hc" :key="activeGroup && activeGroup.hc && activeGroup.hc.id" v-if="activeGroup && 1 == activeId">
            <el-radio-group slot="area1" v-model="activeId" size="small" style="text-align: left">
                <el-radio-button label="2">器械</el-radio-button>
                <el-radio-button label="1">耗材</el-radio-button>
            </el-radio-group>
        </item-consumable>
        <form-dialog
            class="form-table-h380 new-flow-view"
            title="创建清点流程"
            :visible.sync="flow.dialogFormVisible"
            width="60%"
            :close-on-click-modal="false"
            :data="flow.data"
            :columns="flowColumns"
            @confirm="createFlow"
        >
        </form-dialog>
        <form-dialog
            class="form-table-h380 new-flow-view"
            title="清点查询配置"
            :visible.sync="searchConfig.dialogFormVisible"
            width="30%"
            :close-on-click-modal="false"
            :data="searchConfig.data"
            :columns="searchConfigColumns"
            @confirm="saveSearchConfig"
        >
        </form-dialog>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
import ItemInstrument from './ItemInstrument'
import ItemConsumable from './ItemConsumable'
function generateUUID() {
    var d = new Date().getTime()
    var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c == `x` ? r : (r & 0x3 | 0x8)).toString(16)
    })
    return uuid
}
export default {
    name: `Inventory`,
    components: { ItemInstrument, ItemConsumable },
    props: {

    },
    inject: [`reload`],
    data() {
        return {
            title: `清点`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            packageWithBarcode: this.$root.PackageWithBarcode,
            surgeryId: this.$route.query.surgery_id,
            flow: {
                dialogFormVisible: false,
                data: {
                    sys_counting_config_id_qx: undefined,
                    sys_counting_config_id_qx_content: `--`,
                    sys_counting_config_id_hc: undefined,
                    sys_counting_config_id_hc_content: `--`,
                    p1: `清点流程：`,
                    p2: `签名护士：`,
                    dic_worker_inst: [],
                    dic_worker_circuit: []
                }
            },
            countingConfigs: [],
            surgeryinfo: {},
            allFlows: [],
            activeId: 2,
            active_group_name: undefined,
            searchConfig: {
                dialogFormVisible: false,
                data: {}
            },
            selectByList: [{ label: `下拉框`, value: 1 }, { label: `扫码`, value: 2 }],
            defaultSelectBy: undefined,
            filterScopeList: [{ label: `手术间`, value: 1 }, { label: `领用人`, value: 2 }, { label: `未分配`, value: 3 }],
            defaultFilterScope: undefined
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
    },
    mounted() {
        let that = this
        that.loadCountingConfig().then(() => {
            that.loadAllFlow()
            that.changeUserConfig()
        })
    },
    computed: {
        ...mapGetters([`sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `screenHeight`, `sys_enums`, `userConfigs`, `active_ward`]),
        getworker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        flowColumns() {
            return [{
                type: `p`,
                prop: `p1`,
                label: { content: ` `, position: `top` },
                colspan: 24
            }, {
                type: `radio`,
                prop: `sys_counting_config_id_qx`,
                label: `器械`,
                isListable: true,
                options: _.filter(this.countingConfigs, { enum_count_type: 2 }),
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                colspan: 24,
                change: (that, { row }) => {
                    let req = this.myaxios.get(`/api/AcisSystem/CountingConfig/Get/${row.sys_counting_config_id_qx}`)
                    req.then(data => {
                        let r = _.map(_.orderBy(data.details, `display_order`), d => d.name)
                        row.sys_counting_config_id_qx_content = _.join(r, `->`)
                    })
                }
            }, {
                type: `p`,
                prop: `sys_counting_config_id_qx_content`,
                label: ` `,
                readonly: true,
                colspan: 24
            }, {
                type: `radio`,
                prop: `sys_counting_config_id_hc`,
                label: `耗材`,
                isListable: true,
                options: _.filter(this.countingConfigs, { enum_count_type: 1 }),
                colspan: 24,
                change: (that, { row }) => {
                    let req = this.myaxios.get(`/api/AcisSystem/CountingConfig/Get/${row.sys_counting_config_id_hc}`)
                    req.then(data => {
                        let r = _.map(_.orderBy(data.details, `display_order`), d => d.name)
                        row.sys_counting_config_id_hc_content = _.join(r, `->`)
                    })
                }
            }, {
                type: `p`,
                prop: `sys_counting_config_id_hc_content`,
                label: ` `,
                readonly: true,
                colspan: 24
            }, {
                type: `p`,
                prop: `p2`,
                label: { content: ` `, position: `top` },
                colspan: 24
            }, {
                type: `remotemultiselect`,
                prop: `dic_worker_inst`,
                label: `器械`,
                isListable: true,
                options: (that, { row }) => {
                    return q => {
                        let works = this.isWorkerByDuty == `0` ? this.getworker[`护士`] || [] : this.getworker[`巡回护士`] || []
                        if (q && q.keyword) {
                            return works.filter(d => {
                                return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                            })
                        } else {
                            return works
                        }
                    }
                },
                colspan: 12,
                config: {
                    collapseTags: false
                    // multipleLimit:2
                }
            }, {
                type: `remotemultiselect`,
                prop: `dic_worker_circuit`,
                label: `巡回`,
                isListable: true,
                options: (that, { row }) => {
                    return q => {
                        let works = this.isWorkerByDuty == `0` ? this.getworker[`护士`] || [] : this.getworker[`巡回护士`] || []
                        if (q && q.keyword) {
                            return works.filter(d => {
                                return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                            })
                        } else {
                            return works
                        }
                    }
                },
                colspan: 12,
                config: {
                    collapseTags: false
                    // multipleLimit:2
                }
            }]
        },
        searchConfigColumns() {
            return [
                {
                    type: `select`,
                    prop: `select_by`,
                    label: `选择方式`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: this.selectByList || []
                },
                {
                    type: `multiselect`,
                    prop: `filter_scope`,
                    label: `筛选范围`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: this.filterScopeList || []
                }
            ]
        },
        instFlows() {
            return _.map(_.filter(this.allFlows, { enum_count_type: 2 }), d => {
                d.value = d.id
                d.label = d.workflow_name
                return d
            })
        },
        consumableFlows() {
            return _.filter(this.allFlows, { enum_count_type: 1 }, d => {
                d.value = d.id
                d.label = d.workflow_name
                return d
            })
        },
        activeGroup() {
            let r = _.find(this.allFlows, { group_name: this.active_group_name })
            return r
        }
    },
    methods: {
        changeUserConfig() {
            let that = this
            let selectBy = _.filter(that.userConfigs, { key: `instrumentSelectBy` })
            if (selectBy && selectBy.length > 0) {
                that.defaultSelectBy = selectBy[0]
            }
            let filterScope = _.filter(that.userConfigs, { key: `instrumentFilterScope` })
            if (filterScope && filterScope.length > 0) {
                that.defaultFilterScope = filterScope[0]
            }
            that.searchConfig.data.select_by = that.defaultSelectBy && parseInt(that.defaultSelectBy.value) || (this.packageWithBarcode == `0` ? 1 : 2)
            that.searchConfig.data.filter_scope = (that.defaultFilterScope && that.defaultFilterScope.value.trim().split(`,`).map(d => parseInt(d))) || [2]
        },
        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        loadCountingConfig() {
            return new Promise((resolve, reject) => {
                let wardId = 0
                if (this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    wardId = this.active_ward.origion || 0
                }
                let req = this.myaxios.get(`/api/AcisSystem/CountingConfig/GetByOperatingWard?WardId=${wardId}`)
                req.then(countingConfigs => {
                    this.countingConfigs = _.map(_.filter(countingConfigs, d => !d.is_deleted), d => {
                        return {
                            label: d.workflow_name,
                            value: d.id,
                            code: d.count_type,
                            enum_count_type: d.enum_count_type,
                            is_default: d.is_default
                        }
                    })
                    resolve()
                }).catch(e => reject(e))
            })
        },
        initFlow() {
            let req1 = this.myaxios.get(`/api/Nursing/CountingFlow/GetDefaultWorker?surgeryId=${this.surgeryId}`)
            req1.then((worker) => {
                let groupName = generateUUID()
                let reqs = _.map(_.filter(this.countingConfigs, c => c.is_default), d => {
                    return this.myaxios.post(`/api/Nursing/CountingFlow/AddFlow`, {
                        'biz_surgery_info_id': this.surgeryId,
                        'group_name': groupName,
                        'sys_counting_config_id': d.value,
                        'enum_count_type': d.enum_count_type,
                        'dic_worker_inst_id': worker.instrument_nurse && worker.instrument_nurse.map(c => c.value) || [],
                        'dic_worker_circuit_id': worker.circuit_nurse && worker.circuit_nurse.map(c => c.value) || []
                    })
                })
                this.myaxios.all(...reqs).then(() => {
                    this.loadAllFlow()
                })
            })
        },
        loadAllFlow() {
            if (!this.surgeryId) { return }
            let req = this.myaxios.get(`/api/Nursing/CountingFlow/GetFlow?surgeryId=${this.surgeryId}`)
            req.then(data => {
                let def = _.findIndex(this.countingConfigs, c => c.is_default)
                if (def == -1) {
                    this.$message.warning(`未配置默认流程，无法自动带入`)
                }
                if (data.length == 0 && def > -1) {
                    this.initFlow()
                } else {
                    data = _.reduce(_.groupBy(data, `group_name`), function(result, v, key) {
                        let i = {
                            group_name: key
                        }
                        _.forEach(v, d => {
                            i[d.enum_count_type == 1 ? `hc` : `qx`] = d
                        })
                        result.push(i)
                        return result
                    }, [])
                    if (this.active_group_name == undefined && data.length > 0) {
                        this.active_group_name = data[0].group_name
                    }
                    this.allFlows = _.map(data, (d, index) => {
                        d.label = `清点单${index + 1}`
                        d.value = d.group_name
                        return d
                    })
                }
            }).catch(e => console.log(e))
        },
        loadNewFlowView() {
            let qx = _.filter(this.countingConfigs, { enum_count_type: 2 })
            let hc = _.filter(this.countingConfigs, { enum_count_type: 1 })
            let qxDefault = _.find(qx, d => d.is_default)
            let hcDefault = _.find(hc, d => d.is_default)
            this.flow.data.sys_counting_config_id_qx = qxDefault && qxDefault.value || (qx && qx[0] && qx[0].value)
            this.flow.data.sys_counting_config_id_hc = hcDefault && hcDefault.value || (hc && hc[0] && hc[0].value)
            let req1 = this.myaxios.get(`/api/Nursing/CountingFlow/GetDefaultWorker?surgeryId=${this.surgeryId}`)
            let req2 = this.flow.data.sys_counting_config_id_qx && this.myaxios.get(`/api/AcisSystem/CountingConfig/Get/${this.flow.data.sys_counting_config_id_qx}`)
            let req3 = this.flow.data.sys_counting_config_id_hc && this.myaxios.get(`/api/AcisSystem/CountingConfig/Get/${this.flow.data.sys_counting_config_id_hc}`)
            this.myaxios.all(req1, req2, req3).then(([worker, configQx, configHc]) => {
                console.log(111)
                console.log(configQx)
                let r1 = _.map(_.orderBy(configQx.details, `display_order`), d => d.name)
                this.flow.data.sys_counting_config_id_qx_content = _.join(r1, `->`)
                let r2 = _.map(_.orderBy(configHc.details, `display_order`), d => d.name)
                this.flow.data.sys_counting_config_id_hc_content = _.join(r2, `->`)
                this.flow.data.dic_worker_inst = worker.instrument_nurse || []
                this.flow.data.dic_worker_circuit = worker.circuit_nurse || []
                this.$nextTick(() => {
                    this.flow.dialogFormVisible = true
                })
            })
        },
        setUserConfig() {
            this.searchConfig.dialogFormVisible = true
        },
        saveSearchConfig(row) {
            let that = this
            let editList = []
            if (that.defaultSelectBy) {
                that.defaultSelectBy.value = row.select_by
            } else {
                that.defaultSelectBy = { key: `instrumentSelectBy`, value: row.select_by, description: `器械清点选择方式`, catetory: `器械清点` }
            }
            editList.push(this.defaultSelectBy)
            if (that.defaultFilterScope) {
                that.defaultFilterScope.value = row.filter_scope.join(`,`)
            } else {
                that.defaultFilterScope = { key: `instrumentFilterScope`, value: row.filter_scope.join(`,`), description: `器械清点筛选范围`, catetory: `器械清点` }
            }
            editList.push(this.defaultFilterScope)
            let req = that.myaxios.post(`/api/AcisSystem/UserConfig/ChangeUserConfig`, editList)
            req.then(data => {
                that.$store.dispatch(`ADD_USERCONFIG`).then(() => {
                    that.changeUserConfig()
                    that.searchConfig.dialogFormVisible = false
                    that.$message.success(`配置成功`)
                })
            }).catch(e => {
                that.$message.error(`配置失败`)
            })
        },
        createFlow(row) {
            let groupName = generateUUID()
            let req1 = this.myaxios.post(`/api/Nursing/CountingFlow/AddFlow`, {
                'biz_surgery_info_id': this.surgeryId,
                'group_name': groupName,
                'sys_counting_config_id': row.sys_counting_config_id_qx,
                'enum_count_type': 2,
                'dic_worker_inst_id': row.dic_worker_inst.map(c => c.value),
                'dic_worker_circuit_id': row.dic_worker_circuit.map(c => c.value)
            })
            let req2 = row.sys_counting_config_id_hc && this.myaxios.post(`/api/Nursing/CountingFlow/AddFlow`, {
                'biz_surgery_info_id': this.surgeryId,
                'group_name': groupName,
                'sys_counting_config_id': row.sys_counting_config_id_hc,
                'enum_count_type': 1,
                'dic_worker_inst_id': row.dic_worker_inst.map(c => c.value),
                'dic_worker_circuit_id': row.dic_worker_circuit.map(c => c.value)
            })
            this.myaxios.all(req1, req2).then(() => {
                this.loadAllFlow()
                this.flow.dialogFormVisible = false
            }).catch(e => { console.log(e) })
        },
        deleteFlow() {
            if (this.allFlows.length == 1) {
                this.$message.warning(`至少保留一个清点单`)
                return
            }
            this.$confirm(`是否删除?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let promise = this.myaxios.post(`/api/Nursing/CountingContent/RemoveAllPackages`, _.map(this.activeGroup.qx.count_stage, d => d.id))
                promise.then(() => {
                    let req1 = this.myaxios.delete(`/api/Nursing/CountingFlow/DeleteFlow?flowId=${this.activeGroup.qx.id}`)
                    let req2 = this.activeGroup.hc && this.myaxios.delete(`/api/Nursing/CountingFlow/DeleteFlow?flowId=${this.activeGroup.hc.id}`)
                    this.myaxios.all(req1, req2).then(() => {
                        this.activeId = 2
                        this.active_group_name = undefined
                        this.loadAllFlow()
                    })
                })
            }).catch((e) => {
                console.log(e)
            })
        },
        printFlow() {
            if (this.active_group_name && this.activeGroup) {
                console.log(this.activeGroup, this.activeId)
                let docId = this.$root.DOCUMENT.QDD052
                let req = this.myaxios.get(`/api/AcisSystem/CountingConfig/Get/${this.activeGroup.qx && this.activeGroup.qx.sys_counting_config_id || 0}`)
                let req1 = this.myaxios.get(`/api/AcisSystem/CountingConfig/Get/${this.activeGroup.hc && this.activeGroup.hc.sys_counting_config_id || 0}`)
                this.myaxios.all(req, req1).then(([configQx, configHc]) => {
                    console.log(configQx, configHc)
                    if (this.activeId == 2 && configQx.doc_id) {
                        docId = configQx.doc_id
                    } else if (this.activeId == `1` && configHc.doc_id) {
                        docId = configHc.doc_id
                    } else {
                        docId = configQx.doc_id || configHc.doc_id || this.$root.DOCUMENT.QDD052
                    }
                    console.log(docId)
                    let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                    req2.then(isShow => {
                        this.$store.dispatch(`PRINT_PDF`, {
                            host: this.$root.DOCSERVICE_BASE,
                            params: Object.assign(
                                {
                                    docid: docId,
                                    id1: this.surgeryId,
                                    objId: this.active_group_name
                                },
                                { isShowSendPrintMessage: isShow.value }
                            )
                        })
                    }).catch(e => {
                        console.log(e)
                    })
                })
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.activeId = 2
            this.surgeryId = newUrl.query.surgery_id
            this.active_group_name = undefined
            this.loadAllFlow()
        },
        active_ward: function(newVlaue, oldValue) {
            let that = this
            that.loadCountingConfig().then(() => {
                that.loadAllFlow()
                that.changeUserConfig()
            })
        }
    }
}
</script>
<style scoped>
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
</style>
<style lang="less">
.new-flow-view {
    .p1,
    .p2 {
        font-weight: bold;
    }
}
.un-eq input {
    color: red !important;
}
.inventory-datetime {
    &.el-input--suffix .el-input__inner {
        padding-right: 10px !important;
    }
    &.el-input--prefix .el-input__inner {
        padding-left: 10px !important;
    }
    .el-input__suffix {
        display: none;
    }
    .el-input__prefix {
        display: none;
    }
    input {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Inventory/Index.vue